














import Vue from 'vue';

export default Vue.extend({
  props: {
    title: String,
    description: String,
    link: String,
  },
  computed: {
    fixedTitle: function() {
      return `Schau! Ich habe gerade die Lehrstelle ${this.title} auf Industrielehre für dich entdeckt.`;
      //return `Lehrling (m/w/d) - ${this.title} - Jetzt bewerben!`;
    },
  },
});
